import React, { useEffect, useState } from 'react'
import { documentationImage } from '@/types/DocumentationImages';
import { Pagination } from 'antd';

interface DocumentationImageProps {
    year: number;
    category: string;
}
const PAGE_SIZE = 6;

const DocumentationDetails: React.FC<DocumentationImageProps> = ({ year, category }) => {
    const [selectedImage, setSelectedImage] = useState<string | null>(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [loaded, setLoaded] = useState<{ [key: string]: boolean }>({}); // track loading

    const ImagesToShow =
        category === 'All'
            ? documentationImage.filter(image => image.year === year)
            : documentationImage.filter(image => image.category === category && image.year === year);

    const paginatedImages = ImagesToShow.slice(
        (currentPage - 1) * PAGE_SIZE,
        currentPage * PAGE_SIZE
    );

    useEffect(() => {
        setCurrentPage(1);
    }, [category]);

    useEffect(() => {
        window.scrollTo({ top: 400, behavior: 'smooth' });
    }, [currentPage]);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    const handleImageLoad = (id: string) => {
        setLoaded(prev => ({ ...prev, [id]: true }));
    };

    return (
        <div className="w-10/12 mx-auto flex flex-col items-center gap-5">
            <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-4 w-full">
                {paginatedImages.map((image) => (
                    <div
                        key={image.id}
                        className="border rounded-lg border-gray-300 p-2 flex flex-col items-center cursor-pointer relative"
                        onClick={() => setSelectedImage(image.image)}
                    >
                        {/* Spinner muncul sebelum gambar load */}
                        {!loaded[image.id] && (
                            <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                                <div className="w-8 h-8 border-4 border-gray-400 border-t-transparent rounded-full animate-spin" />
                            </div>
                        )}
                        <img
                            src={image.image}
                            alt={image.category}
                            className={`w-full h-48 object-cover transition-opacity duration-300 ${loaded[image.id] ? 'opacity-100' : 'opacity-0'}`}
                            onLoad={() => handleImageLoad(image.id.toString())}
                        />
                        <div className="flex flex-row self-start ml-3"></div>
                    </div>
                ))}

                {selectedImage && (
                    <div
                        className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center"
                        onClick={() => setSelectedImage(null)}
                    >
                        <img
                            src={selectedImage}
                            alt="Full view"
                            className="max-w-full max-h-full object-cover p-4 border rounded-lg border-gray-500 bg-white cursor-pointer"
                        />
                    </div>
                )}
            </div>

            <Pagination
                current={currentPage}
                pageSize={PAGE_SIZE}
                total={ImagesToShow.length}
                onChange={handlePageChange}
                showSizeChanger={false}
            />
        </div>
    );
};

export default DocumentationDetails;
